import { render } from "./HeroiconsOutlineDatabase.vue?vue&type=template&id=6450ff21"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDatabase.vue"]])

export default __exports__